'use client';
import { useEffect, useState } from 'react';
import Images from './images';
import { db } from '@/lib/db';
import { useDispatch } from 'react-redux';
import { setImagesData } from '@/redux/slices/images/imagesSlice';
import { showSuccessToast, showErrorToast } from "@/components/toast/toast";

interface OfflineImagesProps {
  projectId: string;
  isOffline?: boolean;
}

export default function OfflineImages({ projectId, isOffline }: OfflineImagesProps) {
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    const loadImagesData = async () => {
      if (projectId) {
        try {
          setIsLoading(true);
          const project = await db.getFullProject(projectId);
          
          if (project?.imagesData) {
            dispatch(setImagesData(project.imagesData));
          }
        } catch (error) {
          console.error('Error loading images data:', error);
          showErrorToast('Failed to load images configuration');
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    loadImagesData();
  }, [projectId, dispatch]);

  const handleOfflineSubmit = async (values: any) => {
    try {
      const project = await db.getFullProject(projectId);
      if (project) {
        await db.projects.update(projectId, {
          ...project,
          imagesData: {
            ...values,
            updatedAt: new Date().toISOString()
          }
        });
        showSuccessToast("Images data saved offline");
      }
    } catch (error) {
      console.error('Error saving images data:', error);
      showErrorToast("Failed to save images data");
    }
  };

  if (isLoading) {
    return <div>Loading images configuration...</div>;
  }

  return (
    <Images 
      projectId={projectId}
      isOffline={isOffline}
      onOfflineSubmit={handleOfflineSubmit}
    />
  );
} 